<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Card stats -->
      <b-row>
        <b-col xl="4" md="6">
          <stats-card title="Total Turno Bs"
                      type="gradient-red"
                      :sub-title="totalGeneralTurnoBs| moneda"
                      icon="ni ni-money-coins"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="4" md="6">
          <stats-card title="Total Turno Dolar"
                      type="gradient-green"
                      :sub-title="totalGeneralTurnoDolar | moneda"
                      icon="ni ni-money-coins"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">12.18%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <!--<b-col xl="3" md="6">
          <stats-card title="Sales"
                      type="gradient-green"
                      sub-title="924"
                      icon="ni ni-money-coins"
                      class="mb-4">

            <template slot="footer">
              <span class="text-danger mr-2">5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>

        </b-col>-->
        <b-col xl="4" md="6">
          <stats-card title="Performance"
                      type="gradient-info"
                      sub-title="49,65%"
                      icon="ni ni-chart-bar-32"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card class="bckgcard" no-body>
              <b-card-header class="border-0">
                  <h3 class="mb-0">Turnos de Caja</h3>
              </b-card-header>
              <div class="card-body table-responsive p-0">
                <table id="ListTurnos" class="table table-hover text-center">
                <tbody >
                  <tr class="thead-light">
                    <th>Nro Turno</th>
                    <th>Caja</th>
                    <th>Fecha Hora Inicial</th>
                    <th>Fecha Hora Final</th>
                    <th>Fact. Inicial</th>
                    <th>Fact. Final</th>
                    <!--<th v-if="$gate.isAllAdminOrUsers()">Monto General</th>-->
                    <th>Cajer@</th>
                    <th>Estatus</th>
                    <th>Acciones</th>
                  </tr>
                  <tr v-for="turno in turnos" :key="turno.idTurno">
                    <td><h3><b-badge variant="primary">{{turno.idTurno}}</b-badge></h3></td>
                    <td><h3><b-badge variant="success">{{turno.caja}}</b-badge></h3></td>
                    <td>{{turno.inicio | myDateTime}}</td>
                    <td>{{turno.fin | myDateTime}}</td>
                    <td>{{turno.facturaInicial | esvacio}}</td>
                    <td>{{turno.facturaFinal | esvacio}}</td>
                    <!--<td v-if="$gate.isAllAdminOrUsers()">{{turno.totalfacturadobs | moneda}}</td>-->
                    <td>
                      <div class="avatar-group">
                          <a v-b-popover.hover.top="'Ver Cajer@'"  @click="verCajero(turno)" href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip"
                            data-original-title="Rio Supermarket">
                              <img alt="Image placeholder" :src="(turno.estatus==1)?'img/theme/user-online.png':'img/theme/userno-online.png'">
                          </a>
                          <!--<a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip"
                            data-original-title="Romina Hadid">
                              <img alt="Image placeholder" src="img/theme/team-2.jpg">
                          </a>
                          <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip"
                            data-original-title="Alexander Smith">
                              <img alt="Image placeholder" src="img/theme/team-3.jpg">
                          </a>
                          <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip"
                            data-original-title="Jessica Doe">
                              <img alt="Image placeholder" src="img/theme/team-4.jpg">
                          </a>-->
                      </div>
                    </td>
                    <!--<td class="text-right"><h4>{{turno.totalfacturadobs | moneda}} Bs.</h4></td>
                    <td class="text-right"><h4>{{turno.totalfacturadodolar | moneda}} $.</h4></td>-->
                    <td ><span :class="{'badge badge-warning':turno.estatus===1,'badge badge-primary':turno.estatus===2,'badge badge-danger':turno.estatus===3, 'badge badge-info':turno.estatus===4,'badge badge-success':turno.estatus===5 }">{{turno.estatus | statusTurno}}</span></td>
                    <td>
                      <!--                        :disabled="(turno.estatus == 1 || turno.estatus == 0 || turno.facturaInicial == '')?true:false"-->
                      <base-button size="sm" type="secondary"
                        v-b-popover.hover.top="'Ver Facturas'"
                        @click="desgloseFactura(turno)"

                        >
                        <i class="fa fa-eye"></i>
                      </base-button>
                      <base-button size="sm" type="primary"
                          v-b-popover.hover.top="'Procesar Turno'"
                          :disabled="(turno.estatus == 1 || turno.estatus == 0 || turno.facturaInicial == '' )?true:false"
                          @click="editModal(turno)">
                        <i class="fas fa-tasks"></i>
                      </base-button>
                      <!--<base-button size="sm" type="danger" @click="deleteturno(turno.id)">
                        <i class="fa fa-trash"></i>
                      </base-button>-->
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
              <b-card-footer class="py-4 d-flex justify-content-end">
                  <base-pagination aria-controls="ListTurnos" v-model="currentPage" :per-page="perPage" @change="getResults" :total="30"></base-pagination>
              </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
      <div class="mt-5"></div>
    </b-container>

    <b-modal id="modalArqueo" ref="modal-1" size="xl"  hide-footer>
        <template #modal-title>
            <h2 class="modal-title" v-show="!editmode" id="addNewLabel">Guardar Arqueo de Caja Turno: {{turnoSelected.idTurno}}</h2>
            <h2 class="modal-title" v-show="editmode" id="addNewLabel">Actualizar Arqueo de Caja Turno: {{turnoSelected.idTurno}}</h2>
        </template>
          <form @submit.prevent="editmode ? updateCaja() : createCaja()">
            <b-row><!--Detalle de Arqueo-->
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Fecha:
                    <b-badge variant="primary">{{turnoSelected.fecha | myDate}}</b-badge>
                      <!--<b-form-input class="form-control" :disabled="deshabilitadoFecha" size="sm" v-model="filtro.fecha" type="date" value="2021-01-04" id="fecha"></b-form-input>-->
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Arqueo:
                    <b-badge variant="primary"><h6>{{turnoSelected.idTurno}}</h6></b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Hora Inicio:
                    <b-badge variant="primary" pill>{{turnoSelected.inicio | myTime}} </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Codigo Caja:
                    <b-badge variant="primary" pill><h6>{{turnoSelected.caja}}</h6></b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Hora Fin:
                    <b-badge variant="primary" pill>{{turnoSelected.fin | myTime}}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Cajer@:
                    <b-badge variant="primary"><h6>{{dataCajera.apellido}}, {{dataCajera.nombre}}</h6></b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col xl="3" md="6">
                  <b-button v-if="esGuardado || turnoSelected.estatus===4"
                     @click="resetArqueo(turnoSelected)"
                     variant="danger"
                     v-b-popover.hover.top="'Eliminar Arqueo'"
                     size="lg"><i class="fas fa-trash-alt"></i></b-button>
              </b-col>
            </b-row>
            <hr class="my-3">
            <b-row>
              <b-col xl="8" md="8">
                <b-card no-body>
                  <table class="table table-striped" >
                    <tr>
                      <th scope="row">&nbsp;</th>
                      <th v-if="$gate.isAllAdminOrUsers()">Según sistema</th>
                      <th><b>Según Cajer@</b></th>

                    </tr>
                    <tr>
                    <tr>
                      <th scope="row">Fondo Caja</th>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr v-for="mdfp in masterDetalleFP" :key="mdfp.formaPagoId">
                      <th scope="row">{{mdfp.descripcion}}</th>
                      <td v-if="$gate.isAllAdminOrUsers()" class="text-right">{{mdfp.totalFormaPago| moneda}}</td>
                      <td class="text-right fondo">{{mdfp.totalPagoSegunCaja| moneda}}</td>
                      <td v-if="turnoSelected.estatus>=2" class="text-right textMontoG" :class="{'bckgfaltante':(mdfp.totalPagoSegunCaja-mdfp.totalFormaPago).toFixed(2)<0, 'bckgsobrante':(mdfp.totalPagoSegunCaja-mdfp.totalFormaPago).toFixed(2)>0}">{{ faltaOSobra(mdfp) }}</td>
                      <td v-if="turnoSelected.estatus>=2" class="text-right textMontoG" :class="{'bckgfaltante':totalTiposPago(mdfp)<0, 'bckgsobrante':totalTiposPago(mdfp)>0}">{{ totalTiposPago(mdfp)| moneda}}</td>
                    </tr>
                    <tr v-if="dataDevolucion" class="fondo">
                      <th>Devoluciones</th>
                      <td class="text-right textDevolucion">{{dataDevolucion.total | moneda}}</td>
                      <td colspan="3"></td>
                    </tr>
                    <tr class="bckgbs">
                      <th scope="row">Total Bs</th>
                      <td v-if="$gate.isAllAdminOrUsers()" class="text-right textMontoG">{{(totalGeneralMDBs+dataDevolucion.total)  | moneda}}</td>
                      <td class="text-right textMontoG">{{totalFacturadoBs | moneda}}</td>
                      <td v-if="turnoSelected.estatus>=2" :class="{'bckgfaltante':(totalGeneralSCBs-(totalGeneralMDBs+dataDevolucion.total))<0, 'bckgsobrante':(totalGeneralSCBs-(totalGeneralMDBs+dataDevolucion.total))>0}">{{ faltaOSobraTotal(totalGeneralSCBs,(totalGeneralMDBs+dataDevolucion.total)) }}</td>
                      <td v-if="turnoSelected.estatus>=2" class="text-right textMontoG" :class="{'bckgfaltante':(totalGeneralSCBs-(totalGeneralMDBs+dataDevolucion.total))<0, 'bckgsobrante':(totalGeneralSCBs-(totalGeneralMDBs+dataDevolucion.total))>0}">{{calcularDiferencia(totalGeneralSCBs, (totalGeneralMDBs+dataDevolucion.total))| moneda}}</td><!--(totalGeneralSCBs-totalGeneralMDBs).toFixed(2)  $ (totalFacturadoDolar-totalGeneralMDDolar).toFixed(2)-->
                    </tr>
                    <tr class="bckgdolar">
                      <th scope="row">Total Dolar</th>
                      <td v-if="$gate.isAllAdminOrUsers()" class="text-right textMontoG">{{totalGeneralMDDolar | moneda}}</td>
                      <td class="text-right textMontoG">{{totalFacturadoDolar | moneda}}</td>
                      <td v-if="turnoSelected.estatus>=2" :class="{'bckgfaltante':( (totalFacturadoDolar.toFixed(2)-totalGeneralMDDolar.toFixed(2)))<0, 'bckgsobrante':( totalFacturadoDolar.toFixed(2)-totalGeneralMDDolar.toFixed(2))>0}">{{ faltaOSobraTotal(totalFacturadoDolar.toFixed(2),totalGeneralMDDolar.toFixed(2)) }}</td>
                      <td v-if="turnoSelected.estatus>=2" class="text-right textMontoG" :class="{'bckgfaltante':(totalFacturadoDolar.toFixed(2)-totalGeneralMDDolar.toFixed(2))<0, 'bckgsobrante':(totalFacturadoDolar.toFixed(2)-totalGeneralMDDolar.toFixed(2))>0}">  {{ calcularDiferencia(totalFacturadoDolar, totalGeneralMDDolar)| moneda}}</td>
                    </tr>
                    <!--<tr>
                      <th>Total General Turno</th>
                      <td class="text-right textMontoG">{{turnoSelected.totalfacturadobs | moneda}} Bs</td>
                      <td class="text-right textMontoG">{{turnoSelected.totalfacturadodolar | moneda}} $</td>
                    </tr>
                    <tr>
                      <th>Total General </th>
                      <td class="text-right textMontoG">{{acumBs | moneda}} Bs</td>
                      <td class="text-right textMontoG">{{acumDolar | moneda}} $</td>
                    </tr> -->
                  </table>
                </b-card>
              </b-col>
              <b-col xl="4" md="4">
                <!-- Tabs Tipos de Pago -->
                <b-row>
                  <!--<b-form-select :class="{'disable':this.selectTipoPago.length-1==0}" class="col-3" v-model="tipoPago" size="sm" :options="selectTipoPago"></b-form-select>-->
                  <b-button v-if="turnoSelected.estatus!==4 && turnoSelected.estatus!==5" @click="validarMontos()" class="col-2" size="sm"><i class="fas fa-plus"></i></b-button>
                  <b-button @click="verComentario()" class="col-2" size="sm"><i class="fas fa-comment-dots"></i></b-button>
                  <b-button v-if="turnoSelected.estatus!==4 && turnoSelected.estatus!==5" @click="removePago()" class="col-2" size="sm"><i class="fas fa-eraser"></i></b-button>

                  <b-button v-if="esGuardado || turnoSelected.estatus===4" @click="cargarDevolucion()" class="col-2" variant="warning" size="sm"><i class="fas fa-undo-alt"></i></b-button>


                  <b-button v-if="(esGuardado || turnoSelected.estatus===4) && $gate.isAllAdminOrUsers()" @click="validarArqueo(turnoSelected)" class="col-2" variant="success" size="sm"><i class="fas fa-check-double"></i></b-button>
                  <b-button v-if="!esGuardado && (turnoSelected.estatus!==4 && turnoSelected.estatus!==5)" @click="guardarArqueo()" class="col-2" variant="success" size="sm"><i class="fas fa-check"></i></b-button>
                  <b-button v-if="esGuardado || turnoSelected.estatus===4" @click="imprimirArqueo()" class="col-2" variant="info" size="sm"><i class="fas fa-print"></i></b-button>
                  <b-button size="sm" class="col-2" variant="danger" @click="cerrarViewArqueo()"><i class="fas fa-sign-out-alt"></i></b-button>
                </b-row>
                <hr class="my-3">
                <b-row xl="12" md="12">
                  <b-card no-body>
                    <b-list-group>
                      <b-list-group-item  v-for="mp in  metodoPagos" :key="mp.value" class="d-flex justify-content-between align-items-center">
                        <b-button @click="verDetallePago(mp)"  variant="info" size="sm">{{mp.value}} - {{mp.nombre}}</b-button>
                        <b-badge variant="primary" ><b-form-input :disabled="mp.value==2 || mp.value==12 || mp.value==5 || mp.value==7 || mp.value==8" :ref="'inputx_'+mp.value"  class="form-control" size="sm" v-model="mp.monto" type="text" placeholder="0" :id="'monto_'+mp.value"></b-form-input></b-badge>
                      </b-list-group-item> <!-- @change="onChangeMonto(mp)" @keydown="onChangeMonto(mp)"-->
                    </b-list-group>
                  </b-card>
                </b-row>
              </b-col>
            </b-row>
          </form>
    </b-modal>

    <!-- Detalle Detalle Cajera -->
    <b-modal ref="modal-Detalle" hide-backdrop  size="sm" ok-only>
      <template #modal-title>
        <h5 class="modal-title">Detalles de Cajer@</h5>
      </template>
      <b-list-group flush class="list my--3">
          <b-list-group-item
              class="list-group-item px-0">
              <b-row align-v="center" >
                  <b-col md="auto">
                      <!-- Avatar -->
                      <a href="javascript:;" class="avatar">
                          <b-img rounded="circle" alt="Image placeholder" :src="(turnoSelected.estatus==1)?'img/theme/user-online.png':'img/theme/userno-online.png'" />
                      </a>
                  </b-col>
                  <b-col class="ml--2">
                      <h4 class="mb-0"> {{dataCajera.nombre}} {{dataCajera.apellido}}
                          <a href="javascript:;"></a>
                      </h4>
                      <span :class="(turnoSelected.estatus==1)?'text-success':'text-danger'">● {{ (turnoSelected.estatus==1)?'Online':'Offline' }}</span>
                      <small></small>
                  </b-col>
                  <b-col md="auto">
                      <b-button type="button" size="sm" variany="primary">Caja: {{turnoSelected.caja}}</b-button>
                  </b-col>
              </b-row>
          </b-list-group-item>
      </b-list-group>
      <template #modal-footer="{ close }">
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="close()"
          >
            Cerrar
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- End Modal Detalle Cajera -->

    <!-- Observaciones -->
    <b-modal ref="modal-Observaciones" size="sm" title="Agregar Observaciones" ok-only>
      <b-form-textarea
      id="textarea"
      v-model="form.observacion"
      placeholder="Ingrese Observaciones..."
      rows="3"
      max-rows="6"
      ></b-form-textarea>
  </b-modal>

    <!-- Devolucion -->
    <b-modal ref="modal-Devolucion" size="md" title="Agregar Devolución" ok-only>
      <b-card bg-variant="light">
        <b-form-group
          label-cols-lg="3"
          label="Datos Devolución"
          label-size="lg"
          label-class="font-weight-bold pt-0"
          class="mb-0"
        >
            <!--description="Ingrese Nro de Devolución" :invalid-feedback="invalidFeedback"
            :state="state"-->
          <b-input-group size="sm" prepend="Nro Dev.">
            <b-form-input size="sm" id="nroDevolucion" type="text" v-model="formDev.nroDevolucion" value="" placeholder="00000000"></b-form-input>
            <b-button size="sm" @click="buscarMontoDevolucion()" type="button"><i class="fas fa-search-dollar"></i></b-button>
          </b-input-group>

          <!--<select name="formaPagoId" @change="onChangeFormaPago" v-model="formDev.formaPagoId" id="formaPagoId" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('formaPagoId') }">
              <option value="0">Todos Formas de Pago</option>
              <option v-for="itemc in formasPago" :value="itemc.id"  v-bind:key="itemc.id">
                  {{itemc.descripcion}}
              </option>
          </select>-->
          <b-input-group size="sm" prepend="Monto">
            <b-form-input size="sm" id="montoDevuelto" type="text" v-model="formDev.montoDevuelto" value="" placeholder="00,00"></b-form-input>
          </b-input-group>
          <b-form-group
            label="Moneda:"
            label-cols-sm="3"
            label-align-sm="right"
            class="mb-0"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-radio-group
              class="pt-2"
              :options="['Bs.', 'Dolar']"
              :aria-describedby="ariaDescribedby"
            ></b-form-radio-group>
          </b-form-group>

        </b-form-group>
      </b-card>
    </b-modal>

      <!-- desglose pagos cajera -->
    <b-modal ref="modal-dpc" size="sm" title="Agregar Detallado" ok-only>
      <b-form-textarea
      id="textarea"
      v-model="form.observacion"
      placeholder="Ingrese Observaciones..."
      rows="3"
      max-rows="6"
      ></b-form-textarea>
    </b-modal>

      <!-- desglose pagos cajera dolar-->
    <b-modal ref="modal-dpc-dolar" size="lg" :title="'Agregar Detallado '+((divisaSelected==2)?'Dolar':'Euro')" ok-only>
      <b-row xl="12" md="12">
        <!--<b-card no-body>-->
          <b-col md="6" v-if="divisaSelected==2">
          <b-list-group>
            <b-list-group-item  v-for="ded in  detalleEfectivoDolar" :key="ded.denominacion" class="d-flex justify-content-between align-items-center">
              {{ded.denominacion}} -
              <b-badge variant="primary" ><b-form-input @change="calcularMonto(ded)" class="form-control" size="sm" v-model="ded.cantidad" type="text" placeholder="0" :id="'monto_'+ded.denominacion+'_'+ded.moneda"></b-form-input></b-badge>
              {{ded.monto | moneda}}
            </b-list-group-item> <!-- @change="onChangeMonto(mp)" @keydown="onChangeMonto(mp)"-->
          </b-list-group>
          Total Dolares: {{totalGeneralDed | moneda}}
          </b-col>
          <b-col  md="6" v-if="divisaSelected==12">
          <b-list-group>
            <b-list-group-item  v-for="ded in  detalleEfectivoEuro" :key="ded.denominacion" class="d-flex justify-content-between align-items-center">
              {{ded.denominacion}} -
              <b-badge variant="primary" ><b-form-input @change="calcularMonto(ded)" class="form-control" size="sm" v-model="ded.cantidad" type="text" placeholder="0" :id="'monto_'+ded.denominacion+'_'+ded.moneda"></b-form-input></b-badge>
              {{ded.monto | moneda}}
            </b-list-group-item> <!-- @change="onChangeMonto(mp)" @keydown="onChangeMonto(mp)"-->
          </b-list-group>
          Total Euros: {{totalGeneralEur | moneda}}
          </b-col>
        <!--</b-card>-->
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="ProcesarDPCDolar()"
          >
            Procesar
          </b-button>
        </div>
      </template>
    </b-modal>

      <!-- desglose pagos cajera Bancos Tarjetas-->
    <b-modal ref="modal-dpc-bt" size="md" title="Agregar Detallado Banco Tarjeta" ok-only>
      <b-row class="text-center" xl="12" md="12">
        <b-card no-body>
          <div>
            <div class="input-group">
              <select class="custom-select" v-model="bancoSelected" id="inputGroupSelect04">
                <option selected>Seleccione</option>
                <option value="10">Sofitasa</option>
                <option value="2">BNC</option>
                <option value="1">Banesco</option>
              </select>
              <div class="input-group-append">
                <b-button size="sm" @click="crearBancoTT(bancoSelected)" type="button">Agregar</b-button>
              </div>
            </div>

            <b-list-group>
              <!--:variant="variantesLG[banco.bancoid-1].variante"-->
              <b-list-group-item v-for="banco in  detalleBantoTipoTarjeta" :key="banco.idbt" class="d-flex justify-content-between align-items-center">
                {{banco.banco}} - {{banco.tipo}}
                <b-badge variant="primary" ><b-form-input v-model="banco.monto" class="form-control" size="sm"  type="text" placeholder="0" :id="'monto_'+banco.idbt"></b-form-input></b-badge>
              </b-list-group-item> <!-- @change="calcularMontoBTT(banco)" @keydown="onChangeMonto(mp)"-->
            </b-list-group>
            Total: {{totalGeneralDBTT | moneda}}
          </div>
        </b-card>
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="ProcesarDPCPDV()"
          >
            Procesar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { jsPDF } from "jspdf";
  import moment from 'moment';
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

  export default {
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
        deshabilitadoFecha:false,
        tipoPago: "",
        editmode: false,
        filtroActivo:false,
        selectEdo:{},
        bancoSelected:1,
        divisaSelected:1,
        formasPago:[],
        turnos: [],
        bancos:[],
        dataCajera:{},
        turnoSelected:{},
        dataDevolucion:[],
        montoValidado:false,
        esGuardado:false,
        montoActual:0,
        totalBancoTT:0,
        totalFacturadoBs:0,
        totalFacturadoDolar: 0,
        impresionCierre:[],
        //desgloseDolarArqueo:[],
        acumBs: 0,
        acumDolar:0,
        perPage:10,
        currentPage: 1,
        form: new Form({
          id:0,
          fecha: '2021-01-04',
          tiendaId:3,
          turnoId: 0,
          usuarioId:0,
          observacion: '',
          estatus: 1,
          detalleArqueo:[],
          desgloseEfectivoD:[],
          desgloseEfectivoE:[],
          desglosePuntoExterno:[]
        }),
        formDev: new Form({
          nroDevolucion:'',
          formaPagoId: 0,
          nroFactura: '',
          montoDevuelto:0
        }),
        filtro: new Form({
          id:0,
          fecha:"2021-01-04",
          caja:'',
          montoBs:0,
          montoDolar:0,
          montoTDC:0,
          montoTDD:0,
          montoZelle:0,
          totalGeneral:0,
        }),
        status: [{value:true, text:"Activo"}, {value:false, text:"Inactivo"}],
        factMayor: [{value:true, text:"Si"}, {value:false, text:"No"}],
        selectTipoPago:[{value:"", text:"Seleccione"},{value:"1", text:"Efectivo Bs"},{value:"2", text:"Efectivo Dolar"},{value:"3", text:"Punto Interno"},{value:"4", text:"Wallet $."},{value:"5", text:"Vuelto Efectivo $."},{value:"6", text:"Pago Zelle"}, {value:"7", text:"Punto Externo"}, {value:"8", text:"TDC Int"},{value:"9", text:"TDD Int"}],
        metodoPagos:[],//metodos de pagos
        masterDetalleFP:[],
        detalleEfectivoDolar:[{denominacion:1, cantidad:0, monto:0, moneda: 1},{denominacion:5, cantidad:0, monto:0, moneda: 1},{denominacion:10, cantidad:0, monto:0, moneda: 1},{denominacion:20, cantidad:0, monto:0, moneda: 1},{denominacion:50, cantidad:0, monto:0, moneda: 1},{denominacion:100, cantidad:0, monto:0, moneda: 1}],
        detalleEfectivoEuro:[{denominacion:1, cantidad:0, monto:0, moneda: 2},{denominacion:5, cantidad:0, monto:0, moneda: 2},{denominacion:10, cantidad:0, monto:0, moneda: 2},{denominacion:20, cantidad:0, monto:0, moneda: 2},{denominacion:50, cantidad:0, monto:0, moneda: 2},{denominacion:100, cantidad:0, monto:0, moneda: 2}],
        detalleBantoTipoTarjeta:[],
        variantesLG:[{id:1,variante:"success"},{id:2,variante:"warning"},{id:3,variante:"secondary"},{id:11,variante:"primary"}]
      };
    },
    methods: {
      getResults(page = 1) {
          if(this.$route.query.hasOwnProperty('idTurno')){
              this.perPage = 50;
          }
        axios.get(this.$gate.getApiUrl()+'CajaAdministrativa/FacturadoXTurnoXFecha?page='+page+'&perPage='+this.perPage+'&fechaActual='+this.filtro.fecha+'&Caja='+this.filtro.caja)
        .then(response => {
          this.turnos = response.data.data;
          if(this.perPage==50){
              let itemEnc = this.turnos.find(m => m.idTurno == this.$route.query.idTurno);
              if(itemEnc){
                this.turnos = [];
                this.turnos.push(itemEnc);
              }
          }
        });
      },
      verCajero(turno){
        this.turnoSelected = turno;
        this.$refs['modal-Detalle'].show();
        axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleCajeraTurno/"+turno.idTurno).then(({ data }) => {this.dataCajera = data.data.cajeraTurno; });
      },
      cerrarViewArqueo(){
        Fire.$emit('AfterCreate');
        this.$refs['modal-1'].hide();
      },
      verComentario(){
        this.$refs['modal-Observaciones'].show();
      },
      cargarDevolucion(){
        this.$refs['modal-Devolucion'].show();
      },
      calcularMonto(ded){
        ded.monto = ded.denominacion * ded.cantidad;
      },
      calcularDiferencia(totalRecaudado, totalDeclarado){
        return (totalRecaudado-totalDeclarado).toFixed(2)
      },
      onChangeFormaPago(){
        //bs
        if(this.formDev.formaPagoId==1 || this.formDev.formaPagoId==3 || this.formDev.formaPagoId==7){
          //this.formDev.montoDevuelto = monto;
        }
        //$
        if(this.formDev.formaPagoId==2 || (this.formDev.formaPagoId==41 || this.formDev.formaPagoId==42) || this.formDev.formaPagoId==5 || this.formDev.formaPagoId==6){
          //this.formDev.montoDevuelto = this.formDev.montoDevuelto/1820000;
        }
      },
      async getDesgloseDolar(){
        //console.log(this.detalleEfectivoDolar)
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DesgloseDolarArqueo/"+this.form.id).then(({ data }) => {
          this.detalleEfectivoDolar = data.data.desgloseDolar;
          this.detalleEfectivoEuro = data.data.desgloseEuro;

        });
      },
      async buscarMontoDevolucion(){
        await axios.get(this.$gate.getApiUrl()+"Devolucion/"+this.formDev.nroDevolucion+"/caja/"+this.turnoSelected.caja+"/turno/"+this.turnoSelected.idTurno).then(({ data }) => {
          this.dataDevolucion = data.data;
          this.formDev.montoDevuelto = this.dataDevolucion.monto;
        });
      },
      verDetallePago(mp){
        this.divisaSelected = mp.value;
        switch(mp.value){
          //case 1:this.$refs['modal-dpc'].show(); break;
          case 2:
            if(this.form.id!=0){
              this.getDesgloseDolar();
            }
           this.$refs['modal-dpc-dolar'].show(); break;
          case 3: break;
          case 7:this.detalleBantoTipoTarjeta= []; this.$refs['modal-dpc-bt'].show();break;
          case 5: break;
          case 12:
            if(this.form.id!=0){
              this.getDesgloseDolar();
            }
           this.$refs['modal-dpc-dolar'].show();
          break;
        }
      },
      ProcesarDPCDolar(){
        let itemMp = this.metodoPagos.find(mp => mp.value==this.divisaSelected);
        itemMp.monto = (this.divisaSelected==2)?this.totalGeneralDed: this.totalGeneralEur;

        this.form.desgloseEfectivoD = this.detalleEfectivoDolar;
        this.form.desgloseEfectivoE = this.detalleEfectivoEuro;
        this.$refs['modal-dpc-dolar'].hide();
      },
      ProcesarDPCPDV(){
        let itemMp = this.metodoPagos.find(mp => mp.value==7);
        itemMp.monto = this.totalGeneralDBTT;
        this.form.desglosePuntoExterno = this.detalleBantoTipoTarjeta;
        this.$refs['modal-dpc-bt'].hide();
      },
      crearBancoTT(bansel){
        let noExiste = this.detalleBantoTipoTarjeta.find(m => m.bancoid === parseInt(bansel));

        if(!noExiste){
          let item = this.bancos.find(m => m.id === parseInt(bansel));

          this.detalleBantoTipoTarjeta.push({idbt: (item.id+"TDC"), tipo: "TDC", monto:0, banco: item.nombre, bancoid:item.id});
          this.detalleBantoTipoTarjeta.push({idbt: (item.id+"TDD"), tipo: "TDD", monto:0, banco: item.nombre, bancoid:item.id});
        }
      },
      totalTiposPago(mdfp){
        return (mdfp.formaPagoId==4 || mdfp.formaPagoId==41 /*|| mdfp.formaPagoId==42*/)?Math.round((mdfp.totalPagoSegunCaja-mdfp.totalFormaPago).toFixed(2)):Math.round(mdfp.totalPagoSegunCaja-mdfp.totalFormaPago);
      },
      faltaOSobraTotal(totalFormaPago,totalPagoSegunCaja){
        let totalgenDolar = Math.round((totalFormaPago-totalPagoSegunCaja).toFixed(2));

        if(totalgenDolar == 0){
          return "Cuadra: ";
        }else{
          if(totalgenDolar < 0){
            return "Faltante: ";
          }else{
            return "Sobrante: ";
          }
        }
      },
      faltaOSobra(mdfp){
        let totalgenDolar = Math.round(mdfp.totalPagoSegunCaja-mdfp.totalFormaPago);

        if(mdfp.formaPagoId==8) return "----";

        if(mdfp.formaPagoId==4 || mdfp.formaPagoId==41 || mdfp.formaPagoId==42 ){
          totalgenDolar = Math.round(mdfp.totalPagoSegunCaja.toFixed(2) - mdfp.totalFormaPago.toFixed(2));//Math.round(mdfp.totalPagoSegunCaja-mdfp.totalFormaPago);
        }

        //if(mdfp.formaPagoId==42) totalgenDolar = mdfp.totalFormaPago-mdfp.totalPagoSegunCaja;

        if(totalgenDolar == 0){
          return "Cuadra: ";
        }else{
          if(totalgenDolar < 0){
            return "Faltante: ";
          }else{
            return "Sobrante: ";
          }
        }
      },
      validaCerosForm(){
        let enc = true;
        this.metodoPagos.forEach( item => {
          if(item.monto==0 && item.value!=8){
              enc = false;
          }
        });
        return enc;
      },
      updateCaja(){
        this.form.put(this.$gate.getApiUrl()+'Modulo/'+this.form.id)
          .then(() => {
            // success
            Fire.$emit('AfterCreate');
            this.$refs['modal-1'].hide();

            this.$swal({
              title: 'Módulo Actualizado',
              icon: 'success',
              showConfirmButton: false,
              toast: true,
              position: 'top-end',
              timer: 3000
            })
          //this.$Progress.finish();
        })
        .catch((e) => {

          //this.$Progress.fail();
        });
        this.hideModal();
      },
      validarArqueo(turnoSelect){
        if(turnoSelect.estatus >= 4){
          //if(this.validaCerosForm()==true){
            this.$swal({
              title: 'Esta Segur@ de Validar el Arqueo?',
              text: 'Los datos se almacenaran al aceptar!',
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Si, Guardar!',
              cancelButtonText: 'No'
            }).then((result) => {
              if (result.value) {
                axios.get(this.$gate.getApiUrl()+'CajaAdministrativa/ValidarArqueoCaja/'+turnoSelect.idTurno+'/user/'+this.$store.state.user.id)
                  .then(() => {
                    // success
                    this.$swal({
                      title: 'Turno Actualizado',
                      icon: 'success',
                      showConfirmButton: false,
                      toast: true,
                      position: 'top-end',
                      timer: 3000
                    })

                    Fire.$emit('AfterCreate');
                    this.$refs['modal-1'].hide();
                  //this.$Progress.finish();
                })
                .catch((e) => {
                this.$swal(
                  'Error',
                  'Verifique la información e intente nuevamente Code: '+e.response.status+" ",
                  'error'
                )
                  //this.$Progress.fail();
                });
                this.esGuardado = true;
              // For more information about handling dismissals please visit
              // https://sweetalert2.github.io/#handling-dismissals
              } else if (result.dismiss === this.swal.DismissReason.cancel) {
                this.$swal(
                  'Cancelled',
                  'Ha ocurrido un error verifique la informacion e intente nuevamente',
                  'error'
                )
              }
            })
        }else{
          this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: 'Por favor, revise todos los montos antes de Guardar el Arqueo!',
            footer: '<a href>Por qué estas viendo este error?</a>'
          })
        }

        /*}else{
            this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: 'Por favor, valide los montos antes de Guardar el Arqueo!',
            footer: '<a href>Por qué estas viendo este error?</a>'
          })
        }*/
      },
      resetArqueo: async function(turnoActual){
          if(turnoActual.estatus==4){
            this.$swal({
              title: 'Esta Seguro de Eliminar el Arqueo?',
              text: 'Los datos se eliminarán al aceptar!',
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Si, Eliminar!',
              cancelButtonText: 'No'
            }).then((result) => {
              if (result.value) {
                //si acepta eliminar Arqueo
                axios.post(this.$gate.getApiUrl()+'CajaAdministrativa/resetarqueo', {
                    campoId: turnoActual.idTurno,
                    userId: this.$store.state.user.id
                }).then(response => {
                    // Respuesta del servidor
                    this.$swal({
                      title: 'Arqueo Eliminado',
                      icon: 'success',
                      showConfirmButton: false,
                      toast: true,
                      position: 'top-end',
                      timer: 3000
                    })
                    this.cerrarViewArqueo();
                }).catch(e => {
                  this.$swal({
                    title: 'Error Eliminando Arqueo',
                    icon: 'error',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end',
                    timer: 3000
                  })
                })

              }//endif
            });
          }//endif turno.estatus==4
      },
      guardarArqueo(){
        if(this.metodoPagos.length>0 && this.montoValidado){
          this.form.usuarioId = this.$store.state.user.id;
          //if(this.validaCerosForm()==true){
            this.$swal({
              title: 'Esta Seguro de Guardar?',
              text: 'Los datos se almacenaran al aceptar!',
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Si, Guardar!',
              cancelButtonText: 'No'
            }).then((result) => {
              if (result.value) {
                this.form.post(this.$gate.getApiUrl()+'CajaAdministrativa/ArqueoCaja')
                  .then(() => {
                    // success
                    this.esGuardado = true;
                    this.$swal({
                      title: 'Arqueo Guardado',
                      icon: 'success',
                      showConfirmButton: false,
                      toast: true,
                      position: 'top-end',
                      timer: 3000
                    })
                  //this.$Progress.finish();
                })
                .catch((e) => {
                    this.$swal(
                      'Error',
                      'Por favor verifique la información:',
                      'error'
                    )
                  //this.$Progress.fail();
                });

              } else if (result.dismiss === this.swal.DismissReason.cancel) {
                this.$swal(
                  'Cancelled',
                  'Your imaginary file is safe :)',
                  'error'
                )
              }
            })

        }else{
            this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: 'Por favor, valide los montos antes de Guardar el Arqueo!',
            footer: '<a href>Por qué estas viendo este error?</a>'
          })
        }
      },
      getFecha(){
        var currentDate = new Date();
        return currentDate.getFullYear()+"-"+(currentDate.getMonth()<9?"0"+(currentDate.getMonth()+1):(currentDate.getMonth()+1))+"-"+(currentDate.getDate()<10?"0"+currentDate.getDate():currentDate.getDate());
      },
      getmyTime(created){
        //return moment(created, 'YYYY-MM-DD').format(format);//moment(created).format('MMMM Do YYYY');
        if(created == null) return "*";
        return moment(created).format('hh:mm a');
      },
      getmyDate(created){
        //return moment(created, 'YYYY-MM-DD').format(format);//moment(created).format('MMMM Do YYYY');
        return moment(created).format('DD/MM/YYYY');
      },
      getmyDateTime(created){
        //moment(date, 'YYYY-MM-DD').format(format);//moment(created).format('MMMM Do YYYY');
        if(created)
          return moment(created).format('DD/MM/YYYY hh:mm a');
        else
          return "----";
      },
      async imprimirArqueo(){
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/ReporteCierreTurno/"+this.turnoSelected.idTurno).then(({ data }) => {this.impresionCierre = data.data; });
        var i;
        var totalRecaudado = 0;
        var totalProcesado = 0;

        var doc = new jsPDF(/*{
          orientation: "landscape",
          unit: "in",
          format: [4, 2]
        }*/);
        doc.setFontSize(10);
        doc.setFont("times", "normal");
        doc.text("           INSIDE MARKET, C.A.         ", 0, 20);
        doc.text("          Tienda Playa el Angel        ", 0, 25);
        doc.text("----------------------------------------", 0, 30);
        doc.text("CIERRE TURNO #: "+this.turnoSelected.idTurno, 0, 35);
        doc.text("CAJA #: "+this.turnoSelected.caja, 0, 45);
        doc.text("CAJER@ #: "+this.dataCajera.nombre+" "+this.dataCajera.apellido, 0, 50);
        doc.text("FECHA: "+this.getmyDate(this.turnoSelected.fecha), 0, 55);
        doc.text("Documento "+((this.turnoSelected.estatus===5)?"Copia":"Original"), 0, 60);
        doc.text("----------------------------------------", 0, 63);
        doc.text("Fact. inicial: "+this.turnoSelected.facturaInicial+" hasta: "+this.turnoSelected.facturaFinal, 0, 66);
        doc.text("----------------------------------------", 0, 68);
        doc.text("Detalles:", 0, 71);
        var ind = 75;
        var detallesCierre = this.impresionCierre.reporte;
        for(i=0; i<detallesCierre.length;i++){
          doc.text(detallesCierre[i].origen+" "+detallesCierre[i].descripcion+": "+this.getMoneda(detallesCierre[i].monto), 0, ind);
          if(detallesCierre[i].origen=="declarado"){
            totalRecaudado+=detallesCierre[i].monto;
          }
          if(detallesCierre[i].origen=="procesado"){
            totalProcesado+=detallesCierre[i].monto;
          }
          ind +=4;
        }

        var diferencia = totalRecaudado-totalProcesado;
        doc.text("----------------------------------------", 0, (ind+=3));
        //doc.text("-- SUMARIO --", 0, (ind+=3));
        doc.text("Fecha de cierre: "+this.getmyDate(this.form.fecha), 0, (ind+=3));
        doc.text("Desde: "+this.getmyTime(this.turnoSelected.inicio)+" Hasta: "+this.getmyTime(this.turnoSelected.fin), 0, (ind+=3));
        doc.text("----------------------------------------", 0, (ind+=3));
        //doc.text("Devoluciones: 000000", 0, (ind+=3)/*116*/);
        doc.text(" =====================", 0, (ind+=3)/*119*/);
        doc.text("Total Declarado: "+this.getMoneda(totalRecaudado)+" Bs.", 0, (ind+=3));
        doc.text("Total Recaudado: "+this.getMoneda(totalProcesado)+" Bs.", 0, (ind+=3));
        doc.text(" =====================", 0, (ind+=3));
        doc.text("Diferencia: "+this.getMoneda(diferencia), 0, (ind+=3));
        doc.text((diferencia==0?"(CUADRA)":(diferencia>0)?"(SOBRANTE)":"(FALTANTE)")+"", 0, (ind+=3));
        doc.text("----------------------------------------", 0, (ind+=3));
        if(this.form.observacion != ""){
          doc.text("OBSERVACIONES", 0, (ind+=3));
          if(this.form.observacion.length <= 40){
            doc.text(this.form.observacion, 0, (ind+=3));
          }else{
            doc.text(this.form.observacion.substr(0,40), 0, (ind+=3));
            doc.text(this.form.observacion.substr(41,80), 0, (ind+=3));
          }
        }
        doc.text("----------------------------------------", 0, (ind+=3));
        doc.text("CAJERO(A): _________________________", 0, (ind+=3));
        doc.text("FIRMA: _________________________", 0, (ind+=3));
        doc.text("C.I.: _________________________", 0, (ind+=3));
        doc.text(" ** Cierre Realizado **", 0, (ind+=4));
        doc.text("Fecha: "+this.getmyDateTime(this.impresionCierre.fechaHora), 0, (ind+=3));

        doc.save("cierre_turno_"+this.turnoSelected.idTurno+"_"+this.turnoSelected.caja+".pdf");
        this.$swal({
          title: 'Imprimiendo Reporte',
          icon: 'info',
          showConfirmButton: false,
          toast: true,
          position: 'top-end',
          timer: 3000
        })
        //Fire.$emit('AfterCreate');
        //this.$refs['modal-1'].hide();
      },
      getUpWord(text){
        return text.charAt(0).toUpperCase() + text.slice(1);
      },
      getMoneda(text){
        if(text!="----"){
        let val = (text/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
        return text
      },
      acumMontos(formaPago, monto){
        //bs
        if(formaPago==1 || formaPago==3 || formaPago==7){
          this.totalFacturadoBs += monto;
        }
        //$
        if(formaPago==2 || (formaPago==4 || formaPago==41 || formaPago==42) || formaPago==5 || formaPago==6 || formaPago==12){
          this.totalFacturadoDolar += monto;
        }
      },
      validarMontos() {
        var i;
        var mon = 0;
        this.montoValidado =true;
        this.totalFacturadoBs = 0;
        this.totalFacturadoDolar = 0;
        for(i=0; i<this.metodoPagos.length; i++){
            if(this.masterDetalleFP[i].formaPagoId == this.metodoPagos[i].value){
              if(/*this.metodoPagos[i].value===42 ||*/ this.metodoPagos[i].value===41){//ojo aqui
                mon = ((-1)*parseFloat(this.metodoPagos[i].monto));
              }else{
                mon= parseFloat(this.metodoPagos[i].monto);
              }
              this.masterDetalleFP[i].totalPagoSegunCaja = mon;
              this.acumMontos(this.masterDetalleFP[i].formaPagoId, mon);

            }
        }
        this.form.tiendaId = this.$gate.getTiendaId();
        this.form.turnoId = this.turnoSelected.idTurno;
        this.form.fecha = this.turnoSelected.fecha,
        this.form.estatus = this.turnoSelected.estatus,
        this.form.detalleArqueo =   this.masterDetalleFP;
      },
      removePago() {
        this.totalFacturadoBs = 0;
        this.totalFacturadoDolar = 0;
        var i;
        for(i=0; i<this.metodoPagos.length; i++){
          this.metodoPagos[i].monto = this.masterDetalleFP[i].totalPagoSegunCaja = 0;
        }
      },
      getTipoPAgo(Id){
        let itemEnc = this.selectTipoPago.find(m => m.value === Id);
        return itemEnc.text;
      },
      desgloseFactura(turno){
        this.$router.push("factura/desglose?fecha="+this.filtro.fecha+"&turno="+turno.idTurno+"&caja="+turno.caja);
      },
      async getDetallePagoTurno(idTurno){ //:  async function
        this.metodoPagos = [];

        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleFormaPago?IdTurno="+idTurno).then(({ data }) => {this.masterDetalleFP = data.data; this.addMontoSeguncajero(); });
        //await axios.get("http://localhost/security/data/DetalleFormaPago.json?IdTurno="+idTurno).then(({ data }) => {this.masterDetalleFP = data.data; this. addMontoSeguncajero(); });
      },
      async getDetallePagoTurnoVerificado(idTurno){
        this.metodoPagos = [];
        this.form.reset();
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleFormaPagoTurnoVerificado?IdTurno="+idTurno).then(({ data }) => {
          this.masterDetalleFP = data.data.detalleFormaPago;
          this.form.fill(data.data.arqueo);
          this.addMontoSeguncajero(1);
        });
      },
      addMontoSeguncajero(turnoVerificado=0){
        this.totalFacturadoBs = 0;
        this.totalFacturadoDolar = 0;
        var i;
        
        if(turnoVerificado ==0){
          for(i=0; i<this.masterDetalleFP.length; i++){
            let obj = {value: this.masterDetalleFP[i].formaPagoId, nombre: this.masterDetalleFP[i].descripcion, monto:0};
            //console.log(this.masterDetalleFP)
            this.metodoPagos.push(obj);
          }
        }else{
          //console.log(this.form.detalleArqueo);
          for(i=0; i<this.form.detalleArqueo.length; i++){
            const objMasterDetalle = this.masterDetalleFP.find( mdp => mdp.formaPagoId === this.form.detalleArqueo[i].formaPagoId );
            if(this.form.detalleArqueo[i].formaPagoId == 5){
              //Aplica el vuelto a lo declarado para hacer el match y coincida a cero en dolares
              this.form.detalleArqueo[i].monto = objMasterDetalle.totalFormaPago;
            }

            if(this.form.detalleArqueo[i].formaPagoId == 8){
              //Aplica el vuelto a lo declarado para hacer el match y coincida a cero en bs
              this.form.detalleArqueo[i].monto = objMasterDetalle.totalFormaPago;
            }            

            this.acumMontos(this.form.detalleArqueo[i].formaPagoId, this.form.detalleArqueo[i].monto);
            if(objMasterDetalle/*this.form.detalleArqueo[i].formaPagoId == this.masterDetalleFP[i].formaPagoId*/){

              this.masterDetalleFP[i].totalPagoSegunCaja = this.form.detalleArqueo[i].monto;
              //objMasterDetalle.totalPagoSegunCaja = ( this.form.detalleArqueo[i].formaPagoId==42)?this.form.detalleArqueo[i].monto*(-1):this.form.detalleArqueo[i].monto;

              let obj = {value: this.form.detalleArqueo[i].formaPagoId, nombre: objMasterDetalle.descripcion, monto:this.form.detalleArqueo[i].monto};
              this.metodoPagos.push(obj);
            }else{
              
              //(objMasterDetalle)?this.form.detalleArqueo[i].monto:0
              if(this.form.detalleArqueo[i].formaPagoId==4){
                //this.acumMontos(this.form.detalleArqueo[i].formaPagoId, this.form.detalleArqueo[i].monto);
                const objWalletPago = this.masterDetalleFP.find( mdp => mdp.formaPagoId === 42 );//wallet pago (+)
                objWalletPago.totalPagoSegunCaja = (this.form.detalleArqueo[i].monto>0)?this.form.detalleArqueo[i].monto:objWalletPago.totalFormaPago;
                let obj = {value: this.form.detalleArqueo[i].formaPagoId, nombre: objWalletPago.descripcion, monto:(this.form.detalleArqueo[i].monto>0)?this.form.detalleArqueo[i].monto:objWalletPago.totalFormaPago};
                this.metodoPagos.push(obj);

                const objWalletDeposito = this.masterDetalleFP.find( mdp => mdp.formaPagoId === 41);//wallet deposito (-)
                objWalletDeposito.totalPagoSegunCaja = (this.form.detalleArqueo[i].monto<0)?((this.form.detalleArqueo[i].monto+objWalletPago.totalPagoSegunCaja)*Math.sign(-1)):objWalletDeposito.totalFormaPago;

                obj = {value: this.form.detalleArqueo[i].formaPagoId, nombre: objWalletDeposito.descripcion, monto:(this.form.detalleArqueo[i].monto<0)?this.form.detalleArqueo[i].monto:objWalletDeposito.totalFormaPago};
                this.metodoPagos.push(obj);
              }
            }

          }
        }
      },
      acumuladoTurno(idTurno){
        var i=0;
        var enc = true;
        this.acumBs = 0;
        this.acumDolar = 0;
        while(i<this.turnos.length && enc){
          if(idTurno == this.turnos[i].idTurno){
            //enc = false;
          }else{
          this.acumBs += this.turnos[i].totalfacturadobs;
          this.acumDolar += this.turnos[i].totalfacturadodolar;
          }
          i++;
        }
      },
      async editModal(turno){
        this.turnoSelected = turno;
        this.divisaSelected = 0;
        this.form.id=0;
        this.editmode = true;
        this.deshabilitadoFecha =true;

        this.detalleEfectivoDolar = [{denominacion:1, cantidad:0, monto:0, moneda: 1},{denominacion:5, cantidad:0, monto:0, moneda: 1},{denominacion:10, cantidad:0, monto:0, moneda: 1},{denominacion:20, cantidad:0, monto:0, moneda: 1},{denominacion:50, cantidad:0, monto:0, moneda: 1},{denominacion:100, cantidad:0, monto:0, moneda: 1}],
        this.detalleEfectivoEuro = [{denominacion:1, cantidad:0, monto:0, moneda: 2},{denominacion:5, cantidad:0, monto:0, moneda: 2},{denominacion:10, cantidad:0, monto:0, moneda: 2},{denominacion:20, cantidad:0, monto:0, moneda: 2},{denominacion:50, cantidad:0, monto:0, moneda: 2},{denominacion:100, cantidad:0, monto:0, moneda: 2}],


        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleCajeraTurno/"+turno.idTurno).then(({ data }) => {this.dataCajera = data.data.cajeraTurno; });
        await axios.get(this.$gate.getApiUrl()+"Devolucion/"+turno.idTurno).then(({ data }) => {this.dataDevolucion = data.data[0]; });

        this.acumuladoTurno(turno.idTurno);
        if(turno.estatus<4){
          this.getDetallePagoTurno(turno.idTurno);
        }else{
          this.getDetallePagoTurnoVerificado(turno.idTurno);
        }

        this.form.tiendaId = this.$gate.getTiendaId();

        this.$refs['modal-1'].show();
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      zfill(number, width=6) {
          var numberOutput = Math.abs(number); /* Valor absoluto del número */
          var length = number.toString().length; /* Largo del número */
          var zero = "0"; /* String de cero */

          if (width <= length) {
              if (number < 0) {
                  return ("-" + numberOutput.toString());
              } else {
                  return numberOutput.toString();
              }
          } else {
              if (number < 0) {
                  return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
              } else {
                  return ((zero.repeat(width - length)) + numberOutput.toString());
              }
          }
      },
      loadTurnos:async function(){
         this.esGuardado = false;
         if (this.$route.query.hasOwnProperty('Caja')) {
           this.filtro.caja = this.$route.query.Caja;
         }
         if(this.$route.query.hasOwnProperty('fecha')){
            this.filtro.fecha = this.$route.query.fecha;
         }



         //localStorage.fecha = this.filtro.fecha;
        //if(this.$gate.isAdminOrAuthor()){
          this.getResults();
          //await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/FacturadoXTurnoXFecha?fechaActual="+this.filtro.fecha+"&Caja="+this.filtro.caja).then(({ data }) => {this.turnos = data.data; });
          //axios.get("http://localhost/security/data/facturadoturnocaja001.json").then(({ data }) => {this.turnos = data.data;});

          await axios.get(this.$gate.getApiUrl()+"Banco").then(({ data }) => {this.bancos = data; });
          await axios.get(this.$gate.getApiUrl()+"FormaPago").then(({ data }) => {this.formasPago = data });

        //}
      },

    },
    watch: {

    },
    computed: {
      /*30() {
        return this.turnos.length
      }, */
      totalGeneralDBTT: function(){
        let total = [];

        Object.entries(this.detalleBantoTipoTarjeta).forEach(([key, val]) => {
           //if(val.formaPagoId==1 || val.formaPagoId==3 || val.formaPagoId==7)
            total.push(parseFloat(val.monto)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralEur: function(){
        let total = [];

        Object.entries(this.detalleEfectivoEuro).forEach(([key, val]) => {
           //if(val.formaPagoId==1 || val.formaPagoId==3 || val.formaPagoId==7)
            total.push(val.monto) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);
      },
      totalGeneralDed: function(){
        let total = [];

        Object.entries(this.detalleEfectivoDolar).forEach(([key, val]) => {
           //if(val.formaPagoId==1 || val.formaPagoId==3 || val.formaPagoId==7)
            total.push(val.monto) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);
      },
      totalGeneralMDBs: function(){

        let total = [];

        Object.entries(this.masterDetalleFP).forEach(([key, val]) => {
           if(val.formaPagoId==1 || val.formaPagoId==3 || val.formaPagoId==7 || val.formaPagoId==8)
            total.push(val.totalFormaPago) // the value of the current key.
        });

        /*if(this.dataDevolucion.hasOwnProperty('total')){
          total.push(this.dataDevolucion.total);
        }*/

        return total.reduce(function(total, num){ return total + num }, 0);
      },
      totalGeneralMDDolar: function(){

        let total = [];

        Object.entries(this.masterDetalleFP).forEach(([key, val]) => {
           if(val.formaPagoId==2 || val.formaPagoId==41 || val.formaPagoId==42 || val.formaPagoId==5 || val.formaPagoId==6 || val.formaPagoId==12)
            total.push(val.totalFormaPago) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralSCBs: function(){

        let total = [];

        Object.entries(this.metodoPagos).forEach(([key, val]) => {
           if(val.value==1 || val.value==3 || val.value==7)
            total.push((val.monto!=="")?parseFloat(val.monto):0) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralSCDolar: function(){
        let total = [];
        Object.entries(this.metodoPagos).forEach(([key, val]) => {
           if(val.value==2 || val.value==4 || val.formaPagoId==42 || val.formaPagoId==41 || val.value==5 || val.value==6 || val.formaPagoId==12){
             //val.monto =
            total.push((val.monto!=="")?(val.formaPagoId==42 || val.formaPagoId==41 )?(-1 * parseFloat(val.monto)):parseFloat(val.monto):0) // the value of the current key.
           }
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralTurnoBs: function(){

        let total = [];

        Object.entries(this.turnos).forEach(([key, val]) => {
            total.push(parseFloat(val.totalfacturadobs)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralTurnoDolar: function(){

        let total = [];

        Object.entries(this.turnos).forEach(([key, val]) => {
            total.push(parseFloat(val.totalfacturadodolar)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
    },
    created(){
      this.loadTurnos();

      Fire.$on('AfterCreate',() => {
        this.loadTurnos();
      });
    }
  };
</script>
<style>
 #modalArqueo{
   font-size: 13px;
 }
 .fondo{
   background: #f5f5f5;
   font-weight: bold;
 }
 .bckgdolar{
   background:#c4f1de;
 }
 .bckgbs{
   background: #bcf1fb;
 }
.bckgfaltante{
   background: #fac7c7;
 }
 .bckgsobrante{
   background: #faf2c7;
 }
  .bckgnormal{
   background: #f5f5f5;
   font-weight: bold;
   text-align: right;
 }
 .textMontoG{
   font-weight: bold;
 }
 .modal-header {
    padding-bottom : 0rem;
    padding-top: 0.5rem;
  }
.both {
  text-decoration-line: underline overline;
}
.green {
  line-height: 1.1;
  border: solid limegreen;
}
.table .thead-light th {
    background-color: #f5f5f5;/*#0a0a0a;*/
    color: #333;
    font-size: 14px;
}
.table th, .table td {
    padding: 1rem;
    vertical-align: top;
    border-top: 1px solid #e9ecef;
}
.bckgcard{
  background: #fff;
}
.barralateral{
  border-right: 1px solid #d2d6de;
}
a {
color:#1D7F31
}
a:hover {
  color: #00a65a;
}
select {
     background: transparent;
     border: none;
     font-size: 14px;
     height: 30px;
     padding: 5px;
     width: 250px;
}
.textDevolucion{
  color: #FF0000;
  font-weight: bold;
}

</style>
